import React from 'react'
import { withRouter } from 'react-router-dom'
import { get } from 'lodash/object'
import * as queryString from 'query-string'

import {
    Checkbox,
    FormControl,
    FormControlLabel,
    InputLabel,
    MenuItem,
    Select,
    Table,
    TableBody,
    TableHead,
    TableRow,
    TextField,
    Typography
} from '@material-ui/core'

import {
    BodyTableCell,
    ContainerDiv,
    FlexBaselineDiv,
    FlexColumnDiv,
    FlexSpaceBetweenDiv,
    formatMainDescription,
    HeaderTableCell,
    OverflowXDiv,
    SectionTableCell
} from '../components/components'

import { EquipmentService } from '../equipment/equipmentService'

import { EquipmentDialogButton } from './maintenanceDialogButton'
import { DateTimeService } from '../utils/dateTimeService'

import { SortHeaderCell } from '../components/sortHeaderCell'
import { FilterDatePicker } from '../components/filterDatePicker'
import { TableFooterWithPaginator } from '../components/tableFooterWithPaginator'
import { InspectionTypeService } from '../inspectionType/inspectionTypeService'
import { CategoryService } from '../category/categoryService'
import { ProductService } from '../product/productService'
import TableCell from '@material-ui/core/TableCell'
import { CollectionViewUpdater } from '../utils/collectionViewUpdater'
import { PrimaryButton } from '../components/components'
import { Tooltip } from 'react-tippy';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import 'react-tippy/dist/tippy.css';

import Spinner from 'react-spinner-material'
import { PageWrap, Card, CardHead, CardBody, PageBanner, CountBadge } from '../components/pageLayout';
import { Wrench } from 'lucide-react';

function calculateStatusColor(status) {
    switch (status) {
        case 'VALID': return 'transparent';
        case 'IMPROPER': return 'rgb(165, 35, 47)';
        case 'EXPIRED': return 'rgb(213, 117, 48)';
        case 'NA': return 'rgb(145, 145, 145)';
        default: throw new Error(`Unimplemented: ${status}`);
    }
}

class EquipmentsPage extends React.Component {

    constructor(props) {
        super(props)

        const { location } = props

        const { view } = queryString.parse(location.search)

        this.collectionUpdater = CollectionViewUpdater.ofMaintenance(this)

        this.state = {
            isLoading: false,
            categories: [],
            inspectionTypes: [],
            products: [],
            filterQuery: '',
            filterStatus: '',
            filterEnabledTagsOnly: true,
            filterCategoryId: '',
            filterInspectionTypeId: '',
            filterProductId: '',
            filterCreateFrom: null,
            filterCreateUpTo: null,
            filterLastInspectionFrom: null,
            filterLastInspectionUpTo: null,
            filterLastInspectionExpirationStatus: view === 'inspections-report' ? 'EXPIRED_OR_EXPIRING' : '',
            filterDueDateFrom: null,
            filterDueDateUpTo: null,
            filterDueDateExpirationStatus: '',
            collection: this.collectionUpdater.collection
        }
    }

    calculateQuery = () => {
        const {
            filterQuery: query,
            filterStatus: status,
            filterEnabledTagsOnly: enabledTagsOnly,
            filterCategoryId: categoryId,
            filterInspectionTypeId: inspectionTypeId,
            filterProductId: productId,
            filterCreateFrom: createFrom,
            filterCreateUpTo: createUpTo,
            filterLastInspectionFrom: lastInspectionFrom,
            filterLastInspectionUpTo: lastInspectionUpTo,
            filterLastInspectionExpirationStatus: lastInspectionExpirationStatus,
            filterDueDateFrom: dueDateFrom,
            filterDueDateUpTo: dueDateUpTo,
            filterDueDateExpirationStatus: dueDateExpirationStatus,
            collection
        } = this.state

        const { field, direction } = collection.sorter

        return {
            query,
            status,
            enabledTagsOnly,
            categoryId,
            inspectionTypeId,
            productId,
            createFrom: createFrom && createFrom.format('YYYY-MM-DD'),
            createUpTo: createUpTo && createUpTo.format('YYYY-MM-DD'),
            lastInspectionFrom: lastInspectionFrom && lastInspectionFrom.format('YYYY-MM-DD'),
            lastInspectionUpTo: lastInspectionUpTo && lastInspectionUpTo.format('YYYY-MM-DD'),
            lastInspectionExpirationStatus,
            dueDateFrom: dueDateFrom && dueDateFrom.format('YYYY-MM-DD'),
            dueDateUpTo: dueDateUpTo && dueDateUpTo.format('YYYY-MM-DD'),
            dueDateExpirationStatus,
            field,
            direction: field && direction
        }
    }

    componentDidMount() {
        this.setState({ isLoading: true })

        EquipmentService.summary().then(items => {
            this.collectionUpdater.initialData(items)
            this.setState({ isLoading: false })
        })

        CategoryService.list().then(categories => this.setState({ categories }))
        InspectionTypeService.list().then(inspectionTypes => this.setState({ inspectionTypes }))
        ProductService.list().then(products => this.setState({ products }))
    }

    downloadPdf = () => EquipmentService.downloadPdf(this.calculateQuery())
    downloadExcel = () => EquipmentService.downloadExcel(this.calculateQuery())

    buildList = () => {
        const { isLoading, collection } = this.state
        const { currentLanguage } = this.props

        if (isLoading) {
            return (
                <TableRow>
                    <BodyTableCell colSpan={9}><Spinner size={50} spinnerColor="#2CA8FF" spinnerWidth={2} visible={true} /></BodyTableCell>
                </TableRow>
            )
        }

        const items = collection.paginator.pagedItems

        if (items.length === 0) {
            return (
                <TableRow>
                    <BodyTableCell colSpan={9}>Lista vazia.</BodyTableCell>
                </TableRow>
            )
        }

        return items.map((equipment, index) => (
            <TableRow key={index} style={{ borderLeftStyle: 'solid', borderLeftWidth: '0.5rem', borderLeftColor: calculateStatusColor(equipment.status), opacity: equipment.enabledTag ? 1 : 0.5 }}>
                <BodyTableCell align='start'>{formatMainDescription(equipment.product.name, equipment.product.sku)}</BodyTableCell>
                <BodyTableCell align='start'>{formatMainDescription(equipment.extraLabel, equipment.extraCode)}</BodyTableCell>
                <BodyTableCell align='start'>{DateTimeService.formatDate(equipment.createdAt)}</BodyTableCell>
                <BodyTableCell align='start'>{equipment.lastMaintenance !== null ? DateTimeService.formatDate(equipment.lastMaintenance.createdAt) : '--/--/--'}</BodyTableCell>
                <BodyTableCell align='start'>{EquipmentService.formatExpirationStatus(equipment.maintenanceStatus, currentLanguage)}</BodyTableCell>
                <BodyTableCell align='start'>{formatMainDescription(get(equipment, 'lastMaintenance.userName'), get(equipment, 'lastMaintenance.userEmail'))}</BodyTableCell>
                <BodyTableCell><EquipmentDialogButton currentLanguage={currentLanguage} equipment={equipment} /></BodyTableCell>
            </TableRow>
        ));
    };

    render() {
        const {
            collection,
            categories,
            inspectionTypes,
            products,
            filterQuery,
            filterStatus,
            filterCategoryId,
            filterInspectionTypeId,
            filterProductId,
            filterEnabledTagsOnly,
            filterCreateFrom,
            filterCreateUpTo,
            filterLastInspectionFrom,
            filterLastInspectionUpTo,
            filterLastInspectionExpirationStatus
        } = this.state

        const {
            currentLanguage
        } = this.props

        const { updateCollection, handleFilterChange, handleSort } = this.collectionUpdater

        const categoryInspectionTypes = inspectionTypes.filter(inspectionType => inspectionType.categoryId === filterCategoryId)
        const inspectionTypeProducts = products.filter(product => product.inspectionTypeId === filterInspectionTypeId)

        const fieldLabelStyle = { fontSize: '0.75rem', fontWeight: 600, color: '#334155', marginBottom: 4 };
        const dateCardStyle = { border: '1px solid #e2e8f0', borderRadius: 10, padding: 16, background: '#fff' };
        const dateCardTitleStyle = { fontWeight: 600, fontSize: '0.9rem', color: '#0f172a', marginBottom: 12 };

        this.clearFilters = (event) => {

            event.preventDefault()

            handleFilterChange({
                categories: [],
                inspectionTypes: [],
                products: [],
                filterQuery: '',
                filterStatus: '',
                filterEnabledTagsOnly: true,
                filterCategoryId: '',
                filterInspectionTypeId: '',
                filterProductId: '',
                filterCreateFrom: null,
                filterCreateUpTo: null,
                filterLastInspectionFrom: null,
                filterLastInspectionUpTo: null,
                filterLastInspectionExpirationStatus: this.view === 'inspections-report' ? 'EXPIRED_OR_EXPIRING' : '',
                filterDueDateFrom: null,
                filterDueDateUpTo: null,
                filterDueDateExpirationStatus: '',
                collection: this.collectionUpdater.collection
            })

            this.componentDidMount()

        }

        return (
            <PageWrap>
                <PageBanner icon={Wrench} title={currentLanguage.maintenances} />

                <Card>
                    <CardHead>Filtros</CardHead>
                    <CardBody>
                    {/* Buscar */}
                    <div style={{ marginBottom: 16 }}>
                        <div style={fieldLabelStyle}>{currentLanguage.search}</div>
                        <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            helperText={currentLanguage.equipment_sku + ", " + currentLanguage.equipment_information + " " + currentLanguage.or + " " + currentLanguage.maintenance_done_by}
                            value={filterQuery}
                            onChange={event => handleFilterChange({ filterQuery: event.target.value })}
                        />
                    </div>

                    {/* ROW 1: dropdowns */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16 }}>
                        <div>
                            <div style={fieldLabelStyle}>{currentLanguage.status}</div>
                            <FormControl fullWidth margin="dense">
                                <Select variant="outlined" displayEmpty value={filterStatus} onChange={event => handleFilterChange({ filterStatus: event.target.value })} inputProps={{ id: 'status-select' }}>
                                    <MenuItem value="">Selecione um status</MenuItem>
                                    <MenuItem value="NA">{currentLanguage.na.toUpperCase()}</MenuItem>
                                    <MenuItem value="VALID">{currentLanguage.valid.toUpperCase()}</MenuItem>
                                    <MenuItem value="EXPIRED">{currentLanguage.expired.toUpperCase()}</MenuItem>
                                    <MenuItem value="IMPROPER">{currentLanguage.improper.toUpperCase()}</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div>
                            <div style={fieldLabelStyle}>{currentLanguage.category}</div>
                            <FormControl fullWidth margin="dense">
                                <Select variant="outlined" displayEmpty value={filterCategoryId} onChange={event => handleFilterChange({ filterCategoryId: event.target.value, filterInspectionTypeId: '' })} inputProps={{ id: 'categoryId-select' }}>
                                    <MenuItem value="">Selecione uma categoria</MenuItem>
                                    {categories.map(category => (
                                        <MenuItem key={category.id} value={category.id}>{category.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                        <div>
                            <div style={fieldLabelStyle}>{currentLanguage.subcategory}</div>
                            <FormControl fullWidth margin="dense">
                                <Select variant="outlined" displayEmpty value={filterInspectionTypeId} onChange={event => handleFilterChange({ filterInspectionTypeId: event.target.value })} inputProps={{ id: 'inspectionTypeId-select' }}>
                                    <MenuItem value="">Selecione uma subcategoria</MenuItem>
                                    {categoryInspectionTypes.map(inspectionType => (
                                        <MenuItem key={inspectionType.id} value={inspectionType.id}>{inspectionType.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                        <div>
                            <div style={fieldLabelStyle}>{currentLanguage.product}</div>
                            <FormControl fullWidth margin="dense">
                                <Select variant="outlined" displayEmpty value={filterProductId} onChange={event => handleFilterChange({ filterProductId: event.target.value })} inputProps={{ id: 'productId-select' }}>
                                    <MenuItem value="">Selecione um produto</MenuItem>
                                    {inspectionTypeProducts.map(product => (
                                        <MenuItem key={product.id} value={product.id}>{product.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </div>

                    {/* Somente tags ativas */}
                    <FormControlLabel
                        style={{ marginTop: 8 }}
                        label={currentLanguage.active_tags_only}
                        control={
                            <Checkbox
                                checked={filterEnabledTagsOnly}
                                onChange={event => handleFilterChange({ filterEnabledTagsOnly: event.target.checked })}
                            />
                        }
                    />

                    {/* ROW 2: date filter cards */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 16, marginTop: 16 }}>
                        {/* Cadastro */}
                        <div style={dateCardStyle}>
                            <div style={dateCardTitleStyle}>{currentLanguage.register}</div>
                            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                                <div style={{ flex: '1 1 120px' }}>
                                    <div style={fieldLabelStyle}>{currentLanguage.from}</div>
                                    <FilterDatePicker disableFuture style={{ width: '100%' }} value={filterCreateFrom} onChange={date => handleFilterChange({ filterCreateFrom: date })} label="" />
                                </div>
                                <div style={{ flex: '1 1 120px' }}>
                                    <div style={fieldLabelStyle}>{currentLanguage.to}</div>
                                    <FilterDatePicker disableFuture style={{ width: '100%' }} value={filterCreateUpTo} onChange={date => handleFilterChange({ filterCreateUpTo: date })} label="" />
                                </div>
                            </div>
                        </div>

                        {/* Última manutenção */}
                        <div style={dateCardStyle}>
                            <div style={dateCardTitleStyle}>{currentLanguage.last_maintenance}</div>
                            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                                <div style={{ flex: '1 1 100px' }}>
                                    <div style={fieldLabelStyle}>{currentLanguage.from}</div>
                                    <FilterDatePicker disableFuture style={{ width: '100%' }} value={filterLastInspectionFrom} onChange={date => handleFilterChange({ filterLastInspectionFrom: date })} label="" />
                                </div>
                                <div style={{ flex: '1 1 100px' }}>
                                    <div style={fieldLabelStyle}>{currentLanguage.to}</div>
                                    <FilterDatePicker disableFuture style={{ width: '100%' }} value={filterLastInspectionUpTo} onChange={date => handleFilterChange({ filterLastInspectionUpTo: date })} label="" />
                                </div>
                                <div style={{ flex: '1 1 120px' }}>
                                    <div style={fieldLabelStyle}>{currentLanguage.status}</div>
                                    <FormControl fullWidth margin="dense">
                                        <Select variant="outlined" displayEmpty value={filterLastInspectionExpirationStatus} onChange={event => handleFilterChange({ filterLastInspectionExpirationStatus: event.target.value })} inputProps={{ id: 'lastInspectionExpirationStatus-select' }}>
                                            <MenuItem value="">Selecione um status</MenuItem>
                                            <MenuItem value="NA">{currentLanguage.na}</MenuItem>
                                            <MenuItem value="VALID">{currentLanguage.valid}</MenuItem>
                                            <MenuItem value="EXPIRED">{currentLanguage.expired}</MenuItem>
                                            <MenuItem value="EXPIRING">{currentLanguage.expiring}</MenuItem>
                                            <MenuItem value="EXPIRED_OR_EXPIRING">{currentLanguage.expired_or_expiring}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{ marginTop: 16 }}>
                        <PrimaryButton onClick={event => this.clearFilters(event)}>{currentLanguage.clear_fields}</PrimaryButton>
                    </div>
                    </CardBody>
                </Card>

                <Card>
                    <CardHead><Wrench size={18} color="#1CA5D9" /> {currentLanguage.maintenances} <CountBadge>{collection.paginator.pagedItems.length}</CountBadge></CardHead>
                <OverflowXDiv>
                    <Table id="table-equipments">
                        <TableHead>
                            <TableRow>
                                <SortHeaderCell sorter={collection.sorter} onSort={handleSort} width="25%" field="product.name">{currentLanguage.equipment_sku}</SortHeaderCell>
                                <SortHeaderCell sorter={collection.sorter} onSort={handleSort} width="10%" field="extraLabel">{currentLanguage.equipment_information}</SortHeaderCell>
                                <SortHeaderCell sorter={collection.sorter} onSort={handleSort} width="10%" field="createdAt">{currentLanguage.register}</SortHeaderCell>
                                <SortHeaderCell sorter={collection.sorter} onSort={handleSort} width="10%" field="lastMaintenance.createdAt"><span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>Última Manutenção
                                    <Tooltip
                                        title={currentLanguage.maintenance_date_Tippy}
                                        arrow={true}
                                        arrowSize={'small'}>
                                        <InfoOutlinedIcon style={{ fontSize: "small" }} />
                                    </Tooltip></span>
                                </SortHeaderCell>
                                <SortHeaderCell sorter={collection.sorter} onSort={handleSort} width="5%" field="maintenanceStatus">Status Manutenção</SortHeaderCell>
                                <SortHeaderCell sorter={collection.sorter} onSort={handleSort} width="10%" field="lastMaintenance.userName">Manutenção Realizada Por</SortHeaderCell>
                                <HeaderTableCell style={{ width: '5%' }} />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.buildList()}
                        </TableBody>
                        <TableFooterWithPaginator collection={collection} onCollectionUpdate={updateCollection} colSpan={9} />
                    </Table>
                </OverflowXDiv>
                </Card>
            </PageWrap>
        );
    }
}

export default withRouter(EquipmentsPage)
